/**
 * Default de deliveryMode no client (cadastro).
 * Env VITE_DEFAULT_DELIVERY_MODE = cache local; servidor (onCreate) é a verdade.
 * Fail-safe: platform.
 */
import type { VendorDeliveryModeSelectable } from '../types';

const ALLOWED = new Set<VendorDeliveryModeSelectable>([
  'platform',
  'platform_then_lalamove',
  'own_delivery',
]);

/** Fail-safe de lançamento — igual ao servidor. */
export const SAFE_CLIENT_DEFAULT_DELIVERY_MODE: VendorDeliveryModeSelectable =
  'platform';

/**
 * Default para novos vendors no client.
 * Preferir VITE_DEFAULT_DELIVERY_MODE=platform no .env.production.
 */
export function getClientDefaultDeliveryMode(): VendorDeliveryModeSelectable {
  try {
    const raw = String(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (import.meta as any).env?.VITE_DEFAULT_DELIVERY_MODE ?? ''
    ).trim();
    if (ALLOWED.has(raw as VendorDeliveryModeSelectable)) {
      return raw as VendorDeliveryModeSelectable;
    }
  } catch {
    /* ignore */
  }
  return SAFE_CLIENT_DEFAULT_DELIVERY_MODE;
}
